import copy from 'fast-copy';
import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { arrayMoveImmutable } from 'array-move';
import { Container, Draggable } from 'react-smooth-dnd';

import Prompt from '../../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../../Shared/Prompt/Actions';

import Condition from './Condition';
import Condition2 from './Condition2';

import { modules, moduleValues } from '../../../../../Shared/utils';
import { getModuleConditions, getModuleLines, getConditionsFromLines } from '../../../../../Functions/utils';
import { getModuleDataName } from '../../../../../Functions/scenarios';


export default function UpdateModule({ module, setModule, handleUpdateModule, handleRemoveModule }) {
  // console.log("21 - module=", module);

  const { t } = useTranslation();
  const [newModule, setNewModule] = useState(copy(module));

  const [lines, setLines] = useState(
    getModuleLines(module.conditions) || []//handleAddLine
  );

  const handleAddCondition = () => {
    const conditions = newModule.conditions.concat({ seq: newModule.conditions.length + 1 });
    setNewModule({ ...newModule, conditions });
  };

  const handleDragCondition = ({ removedIndex, addedIndex }) => {
    const conditions = arrayMoveImmutable(newModule.conditions, removedIndex, addedIndex);
    conditions.forEach((condition, index) => condition.seq = index + 1);
    setNewModule({ ...newModule, conditions });
  };

  const handleChangeCondition = (cond, type, value) => {
    const module = copy(newModule);

    const condition = module.conditions.find(c => c.seq === cond.seq);
    condition[type] = value;

    if (type === 'condition') {
      if (['AND', 'OR'].includes(value)) condition.xtra_desc = null;
      if (!['==', '!=', '>', '<'].includes(value)) condition.xtra_value = null;
    }

    setNewModule(module);
  };

  const handleRemoveCondition = (cond) => {
    const module = copy(newModule);
    module.conditions.splice(cond.seq - 1, 1);
    module.conditions.forEach((condition, index) => condition.seq = index + 1);

    setNewModule(module);
  };



  const handleAddLine = () => {
    // console.log("66 - addline to", lines);

    // const conditions = newModule.conditions.concat({ seq: newModule.conditions.length + 1 });
    const tmpLine = {
      condition: "ANY",
      desc: "",
      extra: (lines.length === 0 ? "" : "AND"),
      first: 0,
      last: 0,
      scModuleId: undefined,
      value: "",
      seq: lines ? lines.length : 0,
    }
    const tmpLines = copy(lines);
    tmpLines.push(tmpLine);
    handleCheckLines(tmpLines);

    setLines(tmpLines);
  };


  const handleChangeLine = (line, type, value) => {
    // const module = copy(newModule);

    // console.log("62 - handleChangeLine=", line, type, value, lines);
    // console.log("67 - handleChangeLine=", lines);

    // const condition = module.conditions.find(c => c.seq === cond.seq);
    // condition[type] = value;
    // lines[line.seq][type] = value;

    // console.log("72 - handleChangeLine=", lines);

    // if (type === 'condition') {
    //   if (['AND', 'OR'].includes(value)) condition.xtra_desc = null;
    //   if (!['==', '!='].includes(value)) condition.xtra_value = null;
    // }

    // const conditions = [];
    // const check = getConditionsFromLines(lines);

    // console.log("80 - postfix=", postfix);

    // /*
    //     condition: "=="​​​
    //     scModuleId: 5243​​
    //     seq: 1​​​
    //     xtra_desc: "param2"​​​
    //     xtra_value: "4294901760"
    // */
    // let seq = 1;
    // for (const element of postfix) {

    //   const cond = {
    //     condition: element.condition,
    //     scModuleId: element.scModuleId,
    //     seq: seq,
    //     xtra_desc: element.xtra_desc,
    //     xtra_value: element.xtra_value
    //   }

    //   conditions.push(cond);
    //   seq++;
    // }
    // console.log("74 - conditions=", conditions);

    // setLines(lines);

    // module.conditions = conditions;

    // handleCheckLines(lines);

    // setNewModule(module);

    lines[line.seq][type] = value;
    handleCheckLines(lines);

    setLines(lines);
  };

  const handleRemoveLine = (line) => {

    lines.splice(line.seq, 1);
    // setNewModule(module);
    if (lines && lines[0] && lines[0].extra)
      lines[0].extra = "";

    handleCheckLines(lines);

    setLines(lines);
  };


  const keepSelectedValueOnDrag = () => {
    let ghost, interval;

    interval = setInterval(() => {
      if (!ghost) {
        ghost = document.getElementsByClassName('smooth-dnd-ghost')?.[0];
      } else {
        const name = document.querySelector('.smooth-dnd-ghost .singleSelect').getAttribute('name');
        clearInterval(interval);
        interval = null;

        if (document.getElementsByName(name)?.[1]) {
          document.getElementsByName(name)[1].value = document.getElementsByName(name)?.[0]?.value;
        }
      }
    }, 1);
  };

  const handleLoadModuleDataName = (moduleId) => {
    // getModuleDataName(moduleId).then(res => {        // USELESS SINCE FIXED VALUES moduleValues IN Shared/utils
    //   console.log("51 - res=", res);
    // })
  }


  const handleCheckLines = (lines) => {

    const postfix = getConditionsFromLines(lines);
    // console.log("175 - postfix=", lines, postfix);
    const conditions = [];

    let seq = 1;
    for (const element of postfix) {

      const cond = {
        condition: element.condition,
        scModuleId: element.scModuleId,
        seq: seq,
        xtra_desc: element.xtra_desc,
        xtra_value: element.xtra_value
      }

      conditions.push(cond);
      seq++;
    }
    // console.log("203 - conditions=", conditions);

    const module = copy(newModule);
    module.conditions = conditions;
    setNewModule(module);
  }


  useEffect(() => {
    // console.log("210 - useEffect=", module, newModule);

    if (newModule.conditions.length === 0) {
      setNewModule({ ...newModule, conditions: [/*{ seq: 1 }*/] })
      handleLoadModuleDataName(newModule.moduleId);
    }
  }, [module]);


  // console.log("221 - newModule=", newModule);
  let wholeModuleAbsent = false;

  if (
    newModule && newModule.conditions && newModule.conditions[0] &&
    newModule.conditions[0].seq === 1 && newModule.conditions[0].xtra_desc === "FAKE_XTRA_DESC_FOR_WHOLE_MODULE_ABSENT"
  ) {
    wholeModuleAbsent = true;
  }

  // console.log("91 - newModule=", newModule);
  // console.log("39 - lines=", lines, getConditionsFromLines(lines));
  // const tmp = getConditionsFromLines(lines);
  // console.log("224 - tmp=", getModuleLines(module.conditions));
  // console.log("225 - tmp=", getModuleConditions(t, newModule.conditions, ''));

  let errorInLines = false;
  if (lines.length > 0 && (getConditionsFromLines(lines).length === 0 || getModuleConditions(t, newModule.conditions, '').text === ""))
    errorInLines = true;

  if (getModuleConditions(t, newModule.conditions, '').error)
    errorInLines = true;

  // console.log("241 - >> errorInLines=", errorInLines);
  // console.log("242 - >> lines.length=", lines.length);
  // console.log("243 - >> getConditionsFromLines(lines).length=", getConditionsFromLines(lines).length);
  // console.log("244 - >> getModuleConditions(t, newModule.conditions, '').text=", getModuleConditions(t, newModule.conditions, '').text);
  // console.log("245 - >> getModuleConditions(t, newModule.conditions, '')=", getModuleConditions(t, newModule.conditions, ''));


  return (
    <Prompt animated>
      <form className="prompt__container animated"
        style={{
          maxWidth: '820px'
        }}
        // onSubmit={(e) => {
        //   console.log("251 - e=", e);
        //   //handleUpdateModule(e, newModule);
        // }}
      >

        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('scenarios.modules.edit')}</h1>

            <div>
              <select
                className="singleSelect"
                value={newModule.moduleId}
                title={t('scenarios.modules.title', { s: '' })}
                onChange={e => {
                  setNewModule({ ...newModule, moduleId: Number(e.target.value), conditions: [/*{ seq: 1 }*/] })

                  setLines([/*{
                    condition: "ANY",
                    desc: "",
                    extra: "",
                    first: 0,
                    last: 0,
                    scModuleId: undefined,
                    value: "",
                    seq: 0,
                  }*/]);

                  handleLoadModuleDataName(Number(e.target.value));
                }}
              >
                {modules.map(module => {
                  //if ((moduleValues[Number(module)] && moduleValues[Number(module)].length > 0) || Number(module) === -1) {
                  return (
                  <option key={module} value={Number(module)}>
                    {Number(module) > 0 && module + ' - '}{t('scenarios.modules.' + module)}
                    </option>
                  )
                  //}
                })}
              </select>

              {(Number(newModule.moduleId) !== -1 || true) && (

                <p className="checkbox"
                  style={{ display: 'block', marginTop: '10px', marginBottom: '40px' }}
                >
                  <input
                    disabled={Number(newModule.moduleId) === -1}
                    id="wholeModuleAbsent"
                    type="checkbox"
                    checked={wholeModuleAbsent}
                    onChange={(e) => {
                      if (wholeModuleAbsent) {
                        setNewModule({
                          ...newModule,
                          conditions: [/*{ seq: 1 }*/]
                        })

                        setLines([/*{
                          condition: "ANY",
                          desc: "",
                          extra: "",
                          first: 0,
                          last: 0,
                          scModuleId: undefined,
                          value: "",
                          seq: 0,
                        }*/]);

                      }
                      else {
                        setNewModule({
                          ...newModule,
                          conditions: [{
                            seq: 1,
                            condition: "NONE",
                            xtra_desc: "FAKE_XTRA_DESC_FOR_WHOLE_MODULE_ABSENT",
                            xtra_value: ""
                          }]
                        });

                        setLines([/*{
                          condition: "ANY",
                          desc: "",
                          extra: "",
                          first: 0,
                          last: 0,
                          scModuleId: undefined,
                          value: "",
                          seq: 0,
                        }*/]);
                      }
                    }}
                  />
                  <label>{t('scenarios.module_data.whole_module_absent')}</label>
                </p>
              )}

              {!!!wholeModuleAbsent &&
                <p>{(getModuleConditions(t, newModule.conditions, '').text || errorInLines) ? getModuleConditions(t, newModule.conditions, '').text : t('scenarios.conditions.none') + '.'}</p>
                // <p>{lines.length !== 0 ? "" : t('scenarios.conditions.none') + '.'}</p>
              }
            </div>
          </div>


          {!!!wholeModuleAbsent &&
          <div className="prompt__content">
              {/* {(newModule.conditions.length > 0) && (
              <Container
                lockAxis="y"
                onDrop={handleDragCondition}
                dragHandleSelector=".drag-handle"
                onDragStart={keepSelectedValueOnDrag}
              >
                {newModule.conditions.map((cond, key) => (
                  <Draggable key={key}>
                    <Condition
                      moduleNumber={Number(newModule.moduleId)}
                      cond={cond}
                      handleChangeCondition={handleChangeCondition}
                      handleRemoveCondition={handleRemoveCondition}
                    />
                  </Draggable>
                ))}
              </Container>
            )}

              <br></br> */}

              {(lines.length > 0) && (
                <Container
                  lockAxis="x|y"
                  onDrop={handleDragCondition}
                  dragHandleSelector=".drag-handle"
                  onDragStart={keepSelectedValueOnDrag}
                >
                  {lines.map((line, key) => {
                    line.seq = key;

                    return (
                      <Draggable key={key}>
                        <Condition2
                          moduleNumber={Number(newModule.moduleId)}
                          line={line}
                          handleChangeLine={handleChangeLine}
                          handleRemoveLine={handleRemoveLine}
                        />
                      </Draggable>
                    )
                  }
                  )}
                </Container>
              )}

            <Button
              className="button"
                // onClick={handleAddCondition}
                onClick={handleAddLine}
              style={{ backgroundColor: 'var(--button-bg)', margin: '0 auto' }}
              startIcon={<span className="material-icons-round">add_circle_outline</span>}
            >
              {t('scenarios.conditions.add')}
                {/* {t('scenarios.lines.add')} */}
            </Button>
          </div>
          }

          {/* <div className="prompt__content">
            <div style={{ margin: '0 auto', padding: '20px 0px 0px 0px' }}>
              {t('scenarios.conditions.reverse_polish.text')} &quot;
              <a href={t('scenarios.conditions.reverse_polish.link')} target="_blank" rel="noreferrer">
                {t('scenarios.conditions.reverse_polish.link_text')}
              </a>&quot;
            </div>
          </div> */}
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" 
            onClick={() => {              
              if ( module.conditions.length === 0){
                handleRemoveModule(module);
              }
              setModule(null)
            }}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary"
            disabled={errorInLines}
            onClick={() => {
              return handleUpdateModule(newModule);
            }}>
            {t('global.confirm')}
          </Button>
         

          {/* <Button className="btnPrimary" type="submit" disabled={errorInLines}>
            {t('global.confirm')}
          </Button> */}
        </PromptActions>
      </form>
    </Prompt>
  );
}
